import { render, staticRenderFns } from "./Venture.vue?vue&type=template&id=5631fef8&scoped=true"
import script from "./Venture.vue?vue&type=script&lang=js"
export * from "./Venture.vue?vue&type=script&lang=js"
import style0 from "./Venture.vue?vue&type=style&index=0&id=5631fef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631fef8",
  null
  
)

export default component.exports